import { z } from "zod";

import {
  UPLOAD_ALLOWED_CONTENT_TYPES,
  UPLOAD_MAX_FILE_SIZE,
  UPLOAD_MIN_FILE_SIZE
} from "../constants/upload";

export const SubscriptionReqSchema = z.object({
  email: z.string().email("Invalid email format")
});
export type SubscriptionReq = z.infer<typeof SubscriptionReqSchema>;

export const UploadImageRespSchema = z.object({
  url: z.string().url()
});
export type UploadImageResp = z.infer<typeof UploadImageRespSchema>;

export const PresignedReqSchema = z.object({
  fileSize: z.number().int().min(UPLOAD_MIN_FILE_SIZE).max(UPLOAD_MAX_FILE_SIZE),
  fileName: z.string().min(1).max(255),
  contentType: z.enum(UPLOAD_ALLOWED_CONTENT_TYPES)
});
export type PresignedReq = z.infer<typeof PresignedReqSchema>;

// Query params come as strings, so we need to coerce fileSize to number
export const PresignedReqQuerySchema = PresignedReqSchema.extend({
  fileSize: z.coerce.number().int().min(UPLOAD_MIN_FILE_SIZE).max(UPLOAD_MAX_FILE_SIZE)
});

export type PresignedReqQuery = z.infer<typeof PresignedReqQuerySchema>;

export const PresignedRespSchema = z.object({
  url: z.string().url()
});

export type PresignedResp = z.infer<typeof PresignedRespSchema>;
